// Shared localized strings for all auth pages. Kept co-located so they are
// trivially editable per-page if needed.
export const AUTH_STRINGS = {
  ar: {
    // Common
    brand: "حساب مجتمع الذكاء الاصطناعي السوري",
    eyebrow: "SAS · الحساب",
    or: "أو",
    continueGoogle: "الاستمرار عبر Google",
    backToSite: "← العودة إلى الموقع",
    // Login
    loginTitle: "تسجيل الدخول",
    loginBody: "سجّل دخولك للحفاظ على مسارك داخل المبادرة.",
    email: "البريد الإلكتروني",
    password: "كلمة المرور",
    loginCta: "تسجيل الدخول",
    loginLoading: "جارٍ تسجيل الدخول…",
    noAccount: "ليس لديك حساب؟",
    createOne: "أنشئ حسابًا",
    // Signup
    signupTitle: "إنشاء حساب جديد",
    signupBody: "أنشئ حسابك في SAS لحفظ تفاعلك ومتابعة المحتوى.",
    name: "الاسم الكامل",
    passwordHint: "8 أحرف على الأقل.",
    signupCta: "إنشاء الحساب",
    signupLoading: "جارٍ إنشاء الحساب…",
    haveAccount: "لديك حساب؟",
    signInHere: "سجّل دخولك",
    // Password validation
    passwordTooShort: "يجب أن تكون كلمة المرور 8 أحرف على الأقل.",
    // Client-side validation (P1 hardening) — shown inline, before any request
    emailRequired: "يُرجى إدخال البريد الإلكتروني.",
    emailInvalid: "يُرجى إدخال بريد إلكتروني صالح.",
    passwordRequired: "يُرجى إدخال كلمة المرور.",
    nameRequired: "يُرجى إدخال اسمك.",
    formHasErrors: "يُرجى مراجعة الحقول المحدّدة أدناه.",
    // Server / network errors, keyed by the normalised error code
    errInvalidCredentials: "البريد الإلكتروني أو كلمة المرور غير صحيحة.",
    errValidation: "تعذّر قبول البيانات المُدخلة. يُرجى مراجعتها والمحاولة مجددًا.",
    errConflict: "يوجد حساب مسجّل بهذا البريد الإلكتروني بالفعل.",
    errRateLimited: "محاولات كثيرة جدًا. يُرجى الانتظار قليلًا ثم المحاولة مجددًا.",
    errNetwork: "تعذّر الاتصال بالخادم. تحقّق من اتصالك بالإنترنت ثم حاول مجددًا.",
    errServer: "حدث خطأ في الخادم. يُرجى المحاولة بعد قليل.",
    errGeneric: "حدث خطأ غير متوقّع. يُرجى المحاولة مجددًا.",
    // Callback
    callbackWorking: "جارٍ إكمال تسجيل الدخول…",
    callbackMissing: "تعذّر الحصول على رمز Google، حاول مجددًا.",
    retry: "العودة إلى تسجيل الدخول",
    // Google sign-in errors (shown when the OAuth callback fails)
    googleErrorGeneric: "تعذّر إكمال تسجيل الدخول عبر Google. يُرجى المحاولة مجددًا.",
    googleErrorUnavailable: "تسجيل الدخول عبر Google غير متاح حاليًا.",
    googleErrorAccessDenied: "تم إلغاء تسجيل الدخول قبل اكتماله.",
    googleErrorNoEmail: "لم يُرجع Google عنوان بريد إلكتروني صالحًا.",
    // Onboarding
    onboardingTitle: "أكمِل حسابك",
    onboardingBody: "مرحبًا في SAS. تأكّد من اسم العرض قبل إنشاء الحساب.",
    displayName: "الاسم الظاهر",
    finish: "إنهاء إنشاء الحساب",
    finishLoading: "جارٍ إنشاء الحساب…",
    onboardingExpired: "انتهت صلاحية الجلسة. يمكنك المحاولة مرّة أخرى.",
    onboardingCookieBlocked: "يبدو أن متصفحك حظر ملفات تعريف الارتباط (الكوكيز)، فلم نتمكّن من إكمال إنشاء الحساب. جرّب فتح الموقع في نافذة عادية وليس وضع التصفّح الخاص، ثم أعد المحاولة.",
    onboardingNetwork: "تعذّر الاتصال بالخادم. تحقّق من اتصالك بالإنترنت ثم حاول مجددًا.",
    onboardingUnexpected: "حدث خطأ غير متوقّع أثناء إنشاء حسابك. حاول مرّة أخرى.",
    // Account
    accountTitle: "حسابي",
    accountBody: "هذه هي صفحة حسابك الأساسية. ستظهر هنا المقالات والأدوات المحفوظة لاحقًا.",
    accountEmail: "البريد الإلكتروني",
    accountMethod: "طريقة تسجيل الدخول",
    methodPassword: "البريد + كلمة المرور",
    methodGoogle: "Google",
    methodBoth: "البريد + Google",
    logout: "تسجيل الخروج",
    // Placeholder future sections
    savedArticlesTitle: "المقالات المحفوظة",
    savedArticlesBody: "احفظ المقالات للعودة إليها في أي وقت. قريبًا.",
    savedToolsTitle: "الأدوات المفضلة",
    savedToolsBody: "احفظ أدواتك المفضلة للوصول إليها بسرعة. قريبًا.",
    comingSoon: "قريبًا",
    navSignIn: "دخول",
    navAccount: "حسابي",
    // Saved items section
    savedItemsTitle: "المفضلة",
    savedItemsBody: "أدواتك ومقالاتك المحفوظة في مكان واحد.",
    savedItemsTabTools: "الأدوات",
    savedItemsTabArticles: "المقالات",
    savedItemsEmpty: "لم تقم بحفظ أي شيء بعد",
    savedItemsBrowseTools: "تصفّح الأدوات",
    savedItemsBrowseArticles: "تصفّح المقالات",
    savedItemsLoading: "جارٍ التحميل\u2026",
  },
  en: {
    brand: "Syrian AI Society · Account",
    eyebrow: "SAS · Account",
    or: "or",
    continueGoogle: "Continue with Google",
    backToSite: "← Back to the site",
    loginTitle: "Sign in",
    loginBody: "Sign in to keep your activity with the SAS community.",
    email: "Email address",
    password: "Password",
    loginCta: "Sign in",
    loginLoading: "Signing in\u2026",
    noAccount: "Don\u2019t have an account?",
    createOne: "Create one",
    signupTitle: "Create your SAS account",
    signupBody: "Create an account to save content and follow along.",
    name: "Full name",
    passwordHint: "At least 8 characters.",
    signupCta: "Create account",
    signupLoading: "Creating account\u2026",
    haveAccount: "Already have an account?",
    signInHere: "Sign in",
    passwordTooShort: "Password must be at least 8 characters.",
    // Client-side validation (P1 hardening) — shown inline, before any request
    emailRequired: "Please enter your email address.",
    emailInvalid: "Please enter a valid email address.",
    passwordRequired: "Please enter your password.",
    nameRequired: "Please enter your name.",
    formHasErrors: "Please review the highlighted fields below.",
    // Server / network errors, keyed by the normalised error code
    errInvalidCredentials: "Incorrect email or password.",
    errValidation: "We couldn\u2019t accept those details. Please review them and try again.",
    errConflict: "An account with this email already exists.",
    errRateLimited: "Too many attempts. Please wait a moment and try again.",
    errNetwork: "We couldn\u2019t reach the server. Check your connection and try again.",
    errServer: "Something went wrong on our side. Please try again shortly.",
    errGeneric: "Something unexpected happened. Please try again.",
    callbackWorking: "Completing sign-in\u2026",
    callbackMissing: "We couldn\u2019t read the Google session. Please try again.",
    retry: "Back to sign in",
    // Google sign-in errors (shown when the OAuth callback fails)
    googleErrorGeneric: "We couldn\u2019t finish signing you in with Google. Please try again.",
    googleErrorUnavailable: "Google sign-in is temporarily unavailable.",
    googleErrorAccessDenied: "Sign-in was cancelled before it completed.",
    googleErrorNoEmail: "Google didn\u2019t return a valid email address.",
    onboardingTitle: "Complete your account",
    onboardingBody: "Welcome to SAS. Please confirm your display name to finish creating your account.",
    displayName: "Display name",
    finish: "Create account",
    finishLoading: "Creating account\u2026",
    onboardingExpired: "Your sign-in expired. Please start again.",
    onboardingCookieBlocked: "Your browser appears to be blocking cookies, so we couldn\u2019t finish creating your account. Try opening the site in a normal (non-private) window with cookies enabled and sign in again.",
    onboardingNetwork: "We couldn\u2019t reach the server. Check your connection and try again.",
    onboardingUnexpected: "Something unexpected happened while creating your account. Please try again.",
    accountTitle: "My account",
    accountBody: "This is the foundation of your SAS account. Saved articles and favourite tools will appear here in a future update.",
    accountEmail: "Email",
    accountMethod: "Sign-in method",
    methodPassword: "Email + password",
    methodGoogle: "Google",
    methodBoth: "Email + Google",
    logout: "Log out",
    savedArticlesTitle: "Saved articles",
    savedArticlesBody: "Keep articles to come back to any time. Coming soon.",
    savedToolsTitle: "Favourite tools",
    savedToolsBody: "Save your favourite tools for quick access. Coming soon.",
    comingSoon: "Soon",
    navSignIn: "Sign in",
    navAccount: "Account",
    // Saved items section
    savedItemsTitle: "Saved Items",
    savedItemsBody: "Your saved tools and articles in one place.",
    savedItemsTabTools: "Tools",
    savedItemsTabArticles: "Articles",
    savedItemsEmpty: "You haven't saved anything yet",
    savedItemsBrowseTools: "Browse tools",
    savedItemsBrowseArticles: "Browse articles",
    savedItemsLoading: "Loading\u2026",
  },
};
